import { Injectable } from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router} from '@angular/router';
import {CookieService} from 'ngx-cookie';
import {LocalizeRouterService} from '@gilsdav/ngx-translate-router';
import {AccountTypeEnum} from '@shared/enums/account-type.enum';


@Injectable({
  providedIn: 'root'
})
export class AdvertiserGuard implements CanActivate {
  constructor(
    private router: Router,
    private cookie: CookieService,
    private localize: LocalizeRouterService,
  ) {
  }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean {
    const isLoggedIn = this.cookie.get('DWallIsLogged') && this.cookie.get('DWallAccountType') === AccountTypeEnum.advertiser;
    if (!isLoggedIn) {
      const path = this.localize.translateRoute('/');
      this.router.navigate([path]);
    }
    return !!isLoggedIn;
  }
}
